import React from 'react'
import DoublePointTakeoverLogo from './components/DoublePointTakeoverLogo'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import DoublePointTakeoverBackground from './components/DoublePointTakeoverBackground'
import DoublePointTakeoverSubtitleContent from './components/DoublePointTakeoverSubtitleContent'
import DoublePointTakeoverTitleContent from './components/DoublePointTakeoverTitleContent'
import DoublePointTakeoverBannerContent from './components/DoublePointTakeoverBannerContent'
import { SOCIETE_DOUBLE_POINTS_TAKEOVER_ID } from './constants/societeDoublePointsTakeoverConstants'
import DoublePointTakeoverSearchBanner from './components/DoublePointTakeoverSearchBanner'

export const doublePointCampaignId = 'double points December 2025'

const societeDoublePointsTakeoverConfig: App.SiteTakeoverConfigV2 = {
  id: SOCIETE_DOUBLE_POINTS_TAKEOVER_ID,
  palette: 'default',
  verticals: new Set(['home', 'hotel', 'tours', 'cruise']),
  offerTypes: new Set([
    'hotel',
    'cruise',
    'tour', // Tour V1
    'direct_tour', 'partner_tour', 'connection_tour', // Tour V2
    'experience',
  ]),
  backgroundElement: DoublePointTakeoverBackground,
  siteWide: {
    banner: {
      description: <DoublePointTakeoverBannerContent />,
      align: 'start',
      tabletAlign: 'center',
      logo: undefined,
      showOnHomePage: true,
      palette: 'inverse',
    }
  },
  searchPage: {
    bannerContent: <DoublePointTakeoverSearchBanner />,
    hideOnMobileScreenSize: true,
  },
  offerPage: {
    bannerContent: <DoublePointTakeoverBannerContent />,
  },
  campaignTags: new Set([doublePointCampaignId]),
  heroSection: {
    title: <DoublePointTakeoverTitleContent />,
    subtitle: <DoublePointTakeoverSubtitleContent />,
    logo: <CSSBreakpoint min="tablet"><DoublePointTakeoverLogo size="medium" /></CSSBreakpoint>,
    palette: 'default',
    verticals: new Set(['home']),
    filters: [
      { label: 'Dining & Drinks', value: 'Dining & Drinks', type: 'holidayType' },
      { label: 'Family Friendly', value: 'Family Friendly', type: 'holidayType' },
      { label: 'Sun & Beach', value: 'Sun & Beach', type: 'holidayType' },
    ],
  },
}

export default societeDoublePointsTakeoverConfig
